import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { Plus, Pencil, Trash2, GripVertical } from 'lucide-react';
import * as Icons from 'lucide-react';

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typeFilter, setTypeFilter] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editCat, setEditCat] = useState(null);
  const [form, setForm] = useState({ name: '', type: 'expense', icon: 'ShoppingBag', color: '#4F8EF7', parent_id: null });

  const fetchCategories = async () => {
    setLoading(true);
    const params = typeFilter ? { type: typeFilter } : {};
    const res = await api.get('/categories', { params });
    setCategories(res.data);
    setLoading(false);
  };

  useEffect(() => { fetchCategories(); }, [typeFilter]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editCat) {
      await api.put(`/categories/${editCat.id}`, form);
    } else {
      await api.post('/categories', form);
    }
    setShowForm(false); setEditCat(null);
    setForm({ name: '', type: 'expense', icon: 'ShoppingBag', color: '#4F8EF7', parent_id: null });
    fetchCategories();
  };

  const handleDelete = async (id) => {
    if (confirm('Eliminar esta categoria?')) {
      await api.delete(`/categories/${id}`);
      fetchCategories();
    }
  };

  const parentCategories = categories.filter(c => !c.parent_id);
  const iconOptions = ['ShoppingBag', 'Home', 'Car', 'Heart', 'GraduationCap', 'Zap', 'Smartphone',
    'Utensils', 'Plane', 'Gift', 'Gamepad2', 'Shirt', 'Briefcase', 'Building2', 'Coins',
    'TrendingUp', 'Banknote', 'HandCoins', 'PiggyBank', 'Landmark', 'Dumbbell', 'Baby'];

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Categorias</h1>
          <p className="page-subtitle">{categories.length} categorias</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setEditCat(null); setForm({ name: '', type: 'expense', icon: 'ShoppingBag', color: '#4F8EF7', parent_id: null }); setShowForm(true); }}>
          <Plus size={18} /> Nova Categoria
        </button>
      </div>

      {/* Filtro de tipo */}
      <div className="filter-bar">
        {['', 'expense', 'income'].map(t => (
          <button key={t} className={`filter-chip ${typeFilter === t ? 'active' : ''}`}
            onClick={() => setTypeFilter(t)}>
            {t === '' ? 'Todas' : t === 'expense' ? '💸 Despesas' : '💰 Receitas'}
          </button>
        ))}
      </div>

      {/* Lista */}
      <div className="grid-auto">
        {loading ? (
          [1, 2, 3, 4, 5, 6].map(i => <div key={i} className="skeleton" style={{ height: 80, borderRadius: 16 }} />)
        ) : categories.map(cat => {
          const IconComp = Icons[cat.icon] || Icons.Circle;
          return (
            <div key={cat.id} className="card" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ width: 42, height: 42, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', background: `${cat.color}22`, flexShrink: 0 }}>
                <IconComp size={20} color={cat.color} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{cat.name}</div>
                <div style={{ fontSize: 12, color: 'var(--text-tertiary)' }}>
                  <span className={`badge ${cat.type === 'expense' ? 'badge-expense' : 'badge-income'}`}>
                    {cat.type === 'expense' ? 'Despesa' : 'Receita'}
                  </span>
                  {cat.parent_id && <span style={{ marginLeft: 6 }}>Sub-categoria</span>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 4 }}>
                <button className="btn btn-ghost btn-icon" onClick={() => { setEditCat(cat); setForm(cat); setShowForm(true); }}>
                  <Pencil size={14} />
                </button>
                {!cat.is_system && (
                  <button className="btn btn-ghost btn-icon" onClick={() => handleDelete(cat.id)}>
                    <Trash2 size={14} />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal */}
      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">{editCat ? 'Editar Categoria' : 'Nova Categoria'}</h2>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowForm(false)}>✕</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Nome</label>
                  <input className="form-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Tipo</label>
                    <select className="form-input form-select" value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                      <option value="expense">Despesa</option>
                      <option value="income">Receita</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Cor</label>
                    <input type="color" className="form-input" style={{ height: 42, padding: 4 }} value={form.color} onChange={e => setForm({ ...form, color: e.target.value })} />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Ícone</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {iconOptions.map(icon => {
                      const I = Icons[icon] || Icons.Circle;
                      return (
                        <button type="button" key={icon} onClick={() => setForm({ ...form, icon })}
                          style={{
                            width: 38, height: 38, borderRadius: 10, border: form.icon === icon ? `2px solid ${form.color}` : '1px solid var(--border-primary)',
                            background: form.icon === icon ? `${form.color}22` : 'var(--bg-input)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                          }}>
                          <I size={18} color={form.icon === icon ? form.color : 'var(--text-tertiary)'} />
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Categoria Pai (opcional)</label>
                  <select className="form-input form-select" value={form.parent_id || ''} onChange={e => setForm({ ...form, parent_id: e.target.value || null })}>
                    <option value="">Nenhuma (raíz)</option>
                    {parentCategories.filter(c => c.id !== editCat?.id).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">{editCat ? 'Guardar' : 'Criar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
